export const cpfMask = (value) => {
  if (!value) return;
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const cnpjMask = (value) => {
  if (!value) return;
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 2 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const dataMask = (value) => {
  if (!value) return;
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1/$2') // captura 2 grupos de numero o primeiro de 2 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})\d+?$/, '$1');
};

export const retirarMascara = (value) => {
  if (!value) return;
  return value?.replace(/\D/g, ''); // substitui qualquer caracter que nao seja numero por nada
};

export const validaCpfCnpj = (val) => {
  if (val.length === 14) {
    var cpf = val.trim();

    cpf = cpf.replace(/\./g, '');
    cpf = cpf.replace('-', '');
    cpf = cpf.split('');

    var v1 = 0;
    let v2 = 0;
    let aux = false;

    for (var i = 1; cpf.length > i; i++) {
      if (cpf[i - 1] !== cpf[i]) {
        aux = true;
      }
    }

    if (aux === false) {
      return false;
    }

    for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
      v1 += cpf[i] * p;
    }

    v1 = (v1 * 10) % 11;

    if (v1 === 10) {
      v1 = 0;
    }

    if (v1 !== cpf[9]) {
      return false;
    }

    for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
      v2 += cpf[i] * p;
    }

    v2 = (v2 * 10) % 11;

    if (v2 === 10) {
      v2 = 0;
    }

    if (v2 !== cpf[10]) {
      return false;
    } else {
      return true;
    }
  } else if (val.length === 18) {
    var cnpj = val.trim();

    cnpj = cnpj.replace(/\./g, '');
    cnpj = cnpj.replace('-', '');
    cnpj = cnpj.replace('/', '');
    cnpj = cnpj.split('');

    let v1 = 0;
    let v2 = 0;
    let aux = false;

    for (var j = 1; cnpj.length > j; j++) {
      if (cnpj[j - 1] !== cnpj[j]) {
        aux = true;
      }
    }

    if (aux === false) {
      return false;
    }

    for (var k = 0, np1 = 5, np2 = 13; cnpj.length - 2 > k; k++, np1--, np2--) {
      if (np1 >= 2) {
        v1 += cnpj[k] * np1;
      } else {
        v1 += cnpj[k] * np2;
      }
    }

    v1 = v1 % 11;

    if (v1 < 2) {
      v1 = 0;
    } else {
      v1 = 11 - v1;
    }

    if (v1 !== cnpj[12]) {
      return false;
    }

    for (var m = 0, p1 = 6, p2 = 14; cnpj.length - 1 > m; m++, p1--, p2--) {
      if (p1 >= 2) {
        v2 += cnpj[m] * p1;
      } else {
        v2 += cnpj[m] * p2;
      }
    }

    v2 = v2 % 11;

    if (v2 < 2) {
      v2 = 0;
    } else {
      v2 = 11 - v2;
    }

    if (v2 !== cnpj[13]) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const numberLocale = (value) => {
  if (!value) return '';
  return value.toLocaleString('pt-BR');
};

export const numberToPorcent = (value) => {
  if (!value) return;
  return `${value}%`;
};

export const capitalizeFirstLetter = (string) =>
  string?.charAt(0).toUpperCase() + string?.substr(1);

export const normalizeCamelCase = (value) => {
  return value
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
};

export const formatDefaultValueSelect = (value = '') => {
  if (!value  || (typeof value) !== "string") return '';
  return value
    .replaceAll('_', ' ')
    .toLowerCase()
    .split(' ')
    .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
    .join(' ');
};

export const formatDefaultValueSelectRemoveMask = (value = '') => {
  if (!value) return '';
  return value.replaceAll(' ', '_').toUpperCase();
  // .split(' ')
  // .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
  // .join(' ');
};

export const abbrNum = (number, decPlaces) => {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);

  // Enumerate number abbreviations
  var abbrev = ['k', 'm', 'b', 't'];

  // Go through the array backwards, so we do the largest first
  for (var i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    var size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = Math.round((number * decPlaces) / size) / decPlaces;

      // Handle special case where we round up to the next abbreviation
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      // Add the letter for the abbreviation
      number += abbrev[i];

      // We are done... stop
      break;
    }
  }

  return number;
};

export const firstLastName = (nomeCompleto) => {
  var nome = nomeCompleto.split(' ')[0];
  var qtdnome = nomeCompleto.split(' ').length;
  var sobrenome = nomeCompleto.split(' ')[qtdnome - 1];

  if (sobrenome === nome) {
    return nome;
  } else {
    return nome + ' ' + sobrenome;
  }
};

// retorna o dia da semana por sigla
export const diasSemanaSigla = (dia) => {
  switch (dia) {
    case 0:
      dia = 'D';
      break;
    case 1:
      dia = 'S';
      break;
    case 2:
      dia = 'T';
      break;
    case 3:
      dia = 'Q';
      break;
    case 4:
      dia = 'Q ';
      break;
    case 5:
      dia = 'S ';
      break;
    case 6:
      dia = ' S ';
      break;

    default:
      break;
  }
  return dia;
};

// Retorna o dia da semana inteiro
export const diasSemana = (dia) => {
  switch (dia) {
    case 0:
      dia = 'Domingo';
      break;
    case 1:
      dia = 'Segunda';
      break;
    case 2:
      dia = 'Terça';
      break;
    case 3:
      dia = 'Quarta';
      break;
    case 4:
      dia = 'Quinta';
      break;
    case 5:
      dia = 'Sexta';
      break;
    case 6:
      dia = 'Sábado';
      break;

    default:
      break;
  }
  return dia;
};
